module.exports = __webpack_public_path__ + "img/404.10bff875.png";